import { ExportButton } from '@/app/export/ExportButton'
import { ExportEstimate } from '@/app/export/ExportEstimate'
import { ActivePhotoContext } from '@/app/layout/ActivePhotoContext'
import { ToolStrip } from '@/app/layout/ToolStrip'
import { findNode, NodeKind, type ImageNode } from '@/core/document'
import { useEditSession } from '@/core/store/editSession'
import { TEST_IDS } from '@/lib/testIds'
import { ToolTab } from '@/core/store/uiState'
import { getTool } from '@/tools/registry'

export function ToolPanel() {
  const document = useEditSession((state) => state.document)
  const selectedNodeId = useEditSession((state) => state.selectedNodeId)
  const activeTab = useEditSession((state) => state.activeTab)
  if (!document) throw new Error('Tool panel requires a loaded document')
  const selected = selectedNodeId ? findNode(document.root, selectedNodeId) : null
  if (selectedNodeId && !selected) throw new Error(`Active photo "${selectedNodeId}" is missing from the document`)
  if (selected && selected.kind !== NodeKind.Image) {
    throw new Error(`Active photo must be an Image node, received "${selected.kind}"`)
  }
  const activePhoto: ImageNode | null = selected
  const tool = getTool(activeTab)
  if (!tool.appliesTo(activePhoto)) {
    throw new Error(`Active tool "${activeTab}" does not apply to the current photo context`)
  }
  const Panel = tool.Panel

  return (
    <div className="flex h-full min-h-0 flex-col">
      <ToolStrip />
      <ActivePhotoContext />
      <div className="min-h-0 flex-1 overflow-y-auto p-5"><Panel /></div>
      <div className="shrink-0 border-t bg-background p-3" data-testid={TEST_IDS.pinnedExport}>
        <ExportButton className="w-full" showHint />
        {activeTab === ToolTab.Export ? null : <ExportEstimate />}
      </div>
    </div>
  )
}
